import { Client } from '../utils/client';
const ENV_CONFIG = {
  dev: 'https://dqm23rgxerxzo.cloudfront.net',
  uat: 'https://d2sfcixoit4vsx.cloudfront.net',
  prod: 'https://travel.whizcomms.com.sg'
};

const getBaseUrl = () => {
  const host = window.location.hostname;
  
  if (host === 'localhost' || host === 'dqm23rgxerxzo.cloudfront.net') return ENV_CONFIG.dev;
  if (host === 'travel.sharesg.com' || host === 'd2sfcixoit4vsx.cloudfront.net') return ENV_CONFIG.uat;
  
  return ENV_CONFIG.prod;
};

const BASE_URL = getBaseUrl();

/**
 * Initialize API client with base URL
 */
export const initAPIClient = async () => {
  await Client.setBaseURL(BASE_URL);
};

/**
 * Get all products
 */
export const getAllProducts = async (language = 'EN', region = 'SG', promoOnly = true) => {
  try {
    let url = `${BASE_URL}/api/web/order/purchase/product?language=${language}&region=${region}`;
    if (promoOnly) {
      url += '&promoOnly=true';
    }
    const response = await Client.getData(url);
    return response;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

/**
 * Apply promo code
 * @param {string[]} productMasterUuids - Array of product master UUIDs
 * @param {string} promoCode - Promo code to apply
 */
export const applyPromoCode = async (productMasterUuids, promoCode) => {
  try {
    const url = `${BASE_URL}/api/v1/order/promo-code/apply`;
    const body = { productMasterUuids, promoCode };
    const response = await Client.postData(url, body);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Submit purchase
 */
export const submitPurchase = async (purchaseData) => {
  try {
    const url = `${BASE_URL}/api/web/order/purchase/submitPurchase`;
    const body = {
      productMasterUuids: purchaseData.productMasterUuids,
      lastname: purchaseData.lastname,
      firstname: purchaseData.firstname,
      email: purchaseData.email,
      ...(purchaseData.promoCode && { promoCode: purchaseData.promoCode })
    };
    const response = await Client.postData(url, body);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Submit purchase V2 (MasterCard)
 */
export const submitPurchaseV2 = async (purchaseData) => {
  try {
    const url = `${BASE_URL}/api/web/order/purchase/submitPurchaseV2`;
    const body = {
      productMasterUuids: purchaseData.productMasterUuids,
      lastname: purchaseData.lastname,
      firstname: purchaseData.firstname,
      email: purchaseData.email,
      ...(purchaseData.promoCode && { promoCode: purchaseData.promoCode })
    };
    const response = await Client.postData(url, body);
    return response;
  } catch (error) {
    console.error('Error submitting purchase V2:', error);
    throw error;
  }
};

/**
 * Verify email OTP V2 (MasterCard)
 */
export const verifyEmailOTPV2 = async (transactionId, otp, orderDescription) => {
  try {
    const url = `${BASE_URL}/api/web/order/purchase/verifyEmailOTPV2`;
    const body = { transactionId, otp, orderDescription };
    const response = await Client.postData(url, body);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Resend email OTP
 */
export const resendEmailOTP = async (transactionId) => {
  try {
    const url = `${BASE_URL}/api/web/order/purchase/resendEmailOtp`;
    const body = { transactionId };
    const response = await Client.postData(url, body);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Get promo-only product (for redeem page)
 */
export const getPromoProduct = async (language = 'EN', region = 'SG') => {
  try {
    const url = `${BASE_URL}/api/web/product?language=${language}&region=${region}&promoOnly=true`;
    const response = await Client.getData(url);
    return response;
  } catch (error) {
    console.error('Error fetching promo product:', error);
    throw error;
  }
};

/**
 * Get all packages
 */
export const getPackages = async (language = 'EN', region = 'SG') => {
  try {
    const url = `${BASE_URL}/api/web/package?language=${language}&region=${region}`;
    const response = await Client.getData(url);
    return response;
  } catch (error) {
    console.error('Error fetching packages:', error);
    throw error;
  }
};

/**
 * Get FAQ data
 */
export const getFAQData = async () => {
  try {
    const url = `${BASE_URL}/api/web/resource?type=faq`;
    const response = await Client.getData(url);
    return response;
  } catch (error) {
    console.error('Error fetching FAQ data:', error);
    throw error;
  }
};

/**
 * Get MasterCard SDK URL based on environment
 */
export const getMastercardSDKUrl = () => {
  const hostname = window.location.hostname;
  const isDev = hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.includes('dev') ||
    hostname.includes('test') ||
    hostname.includes('staging') ||
    hostname.includes('dqm23rgxerxzo.cloudfront.net');
  const isUAT = hostname.includes('d2sfcixoit4vsx.cloudfront.net') ||
    hostname.includes('travel.sharesg.com');

  if (isDev || isUAT) {
    return 'https://test-gateway.mastercard.com/static/checkout/checkout.min.js';
  } else {
    return 'https://ap-gateway.mastercard.com/static/checkout/checkout.min.js';
  }
  // return 'https://ap-gateway.mastercard.com/static/checkout/checkout.min.js';
};

/**
 * Retrieve order after MasterCard payment
 */
export const retrieveOrder = async (data) => {
  try {
    const url = `${BASE_URL}/api/web/order/purchase/retrieve/order`;
    const response = await Client.postData(url, data);
    return response;
  } catch (error) {
    console.error('Error retrieving order:', error);
    throw error;
  }
};
